import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { REPORT } = API_ROUTES;

class ReportServices {
  createReport = (params: unknown) =>
    sendCall(REPORT.POST, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  getReports = (page: number, pagination: boolean) =>
    sendCall(`${REPORT.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  getReportsSearch = (params: unknown, page: number) =>
    sendCall(`${REPORT.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  getReport = (id: string | undefined) => sendCall(`${REPORT.GET}/${id}`, { method: HTTP_METHODS.GET });

  getExcel = (id: string | undefined) =>
    sendCall(`${REPORT.EXCEL}/${id}`, {
      method: HTTP_METHODS.GET,
      responseType: 'blob',
    });

  getReportPageData = (id: string | undefined, page: number) =>
    sendCall(`${REPORT.PAGE_DATA}/${id}?page=${page}&limit=${PAGE_SIZE}`, {
      method: HTTP_METHODS.GET,
    });
}

export default new ReportServices();
